module.exports = __webpack_public_path__ + "static/media/inspektLogo_lightgrey.d9fcbb88.png";